import { useEffect, useMemo, useRef, useState } from "react";
import { useStateValue } from "../../context/StateProvider";
import { Key, Power, PowerOff, Trash2, UserRoundPen } from "lucide-react";
import DeleteDisable from "./delete-disable-user";
import { Link, useNavigate } from "react-router-dom";
import AccessRole from "./access-role";
import { FaRankingStar } from "react-icons/fa6";
import {
  getAllusers,
  hardDeleteUser,
  updateUserProfile,
} from "../../utils/firebasefunctions";
import { actionType } from "../../context/reducer";
import { UsersRound } from "lucide-react";

function MainUserManagement() {
  const [{ users, user }, dispatch] = useStateValue();
  console.log("user", user);
  console.log("userz", users);
  const [search, setSearch] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [mood, setMood] = useState("");
  const [userId, setUserId] = useState("");
  const [isAccess, setIsAccess] = useState(false);
  const navigate = useNavigate();
  const cleanedRef = useRef(false);

  // One-time cleanup: hard-delete user docs with no name and no email.
  // Runs once per mount, only if there's something to clean.
  useEffect(() => {
    if (cleanedRef.current) return;
    if (!Array.isArray(users) || users.length === 0) return;
    const blanks = users.filter((u) => {
      const f = (u?.firstname || "").trim();
      const l = (u?.lastname || "").trim();
      const e = (u?.email || "").trim();
      return !f && !l && !e;
    });
    if (blanks.length === 0) return;
    cleanedRef.current = true;
    (async () => {
      let removed = 0;
      for (const blank of blanks) {
        try {
          await hardDeleteUser(blank.id);
          removed += 1;
        } catch (err) {
          console.error("Failed to delete blank user", blank.id, err);
        }
      }
      if (removed > 0) {
        try {
          const response = await getAllusers("users");
          dispatch({
            type: actionType.STORE_ALLUSERS,
            teamleads: response.filter((d) => d.role === "Admin"),
            clients: response.filter((d) => d.role === "Supervisor"),
            employees: response,
            allusers: response,
          });
        } catch (err) {
          console.error("Failed to refresh users:", err);
        }
      }
    })();
  }, [users, dispatch]);

  const handleDelete = (id) => {
    setMood("delete");
    setUserId(id);
    setIsOpen(true);
  };

  const handleDisable = (id) => {
    setMood("disabled");
    setUserId(id);
    setIsOpen(true);
  };

  const handleranking = async (item) => {
    try {
      let data = {
        rankingaccess: !item.rankingaccess,
      };

      // 🔹 Update Firebase
      await updateUserProfile(item.id, data);

      getallusers();
    } catch (err) {
    } finally {
    }
  };

  const handleAccess = (id) => {
    setUserId(id);
    setIsAccess(true);
  };

  const filteredUsers = useMemo(() => {
    const text = search.toLowerCase().trim();

    return users
      .filter((item) => {
        // ❌ Admin users skip
        if (item.type === 1) return false;

        // ❌ Hide blank rows (no name + no email) — stale/garbage records
        const hasIdentity =
          (item.firstname || "").trim() ||
          (item.lastname || "").trim() ||
          (item.email || "").trim();
        if (!hasIdentity) return false;

        // ✅ If current user is Supervisor → only show Employees
        if (user?.role === "Supervisor") {
          return item.role === "Employee";
        }

        return true;
      })
      .filter((items) => {
        if (!text) return true;

        const fullName = `${items.firstname || ""} ${items.lastname || ""}`
          .toLowerCase()
          .trim();

        const email = items.email?.toLowerCase() || "";
        const phone = items.phonenumber?.toString().toLowerCase() || "";

        return (
          fullName.includes(text) ||
          email.includes(text) ||
          phone.includes(text)
        );
      });
  }, [users, search, user]);

  async function getallusers() {
    await getAllusers("users")
      .then(async (response) => {
        dispatch({
          type: actionType.STORE_ALLUSERS,
          teamleads: response.filter(function (doc) {
            return doc.role === "Admin";
          }),
          clients: response.filter(function (doc) {
            return doc.role === "Supervisor";
          }),
          employees: response,
          allusers: response,
        });
      })
      .catch((err) => {
        alert(err);
      });
  }
  return (
    <div className="">
      {/* <header className="flex flex-col lg:flex-row justify-between items-center text-center lg:text-left px-10 py-7 lg:py-5 border-b border-black/10 bg-white">
        <div className="page-title">
          <h2 className="text-3xl sm:text-4xl font-bold bg-[#1E293B] bg-clip-text text-transparent">
            User Management
          </h2>
        </div>
        <div class="flex gap-4 mt-4 lg:mt-0">
          <button
            onClick={() => {
              navigate("/dashboard/create-user?page=usermanagment");
            }}
            class="relative inline-flex items-center gap-2 px-6 py-3 font-semibold text-white text-sm rounded-lg bg-gradient-to-b from-[#0f172a] to-[#1E293B] shadow-md hover:-translate-y-1 hover:shadow-lg transition duration-300 overflow-hidden group"
          >
            <span class="absolute inset-0 bg-white/20 rounded-full scale-0 group-hover:scale-150 transition-transform duration-700 ease-out"></span>
            <UsersRound className="h-5 w-5 min-w-[20px]" />
            <span class="relative">Create User</span>
          </button>
        </div>
      </header> */}
      {/* Table */}
      <div className="bg-white rounded-2xl border border-gray-200 shadow-sm overflow-hidden">
        <div className="p-5 flex flex-col md:flex-row justify-between items-start sm:items-center">
          <div className="sm:w-[30%] md:w-[40%] lg:w-[40%]">
            <h2 className="text-xl font-semibold">
              Users
            </h2>
          </div>
          <div className="flex flex-col sm:flex-row w-full gap-3 sm:w-full md:w-[60%] lg:w-[60%] mt-3 lg:mt-0">
            <div className="relative sm:w-[75%] md:w-[65%] xl:w-[70%] 2xl:w-[75%]">
              <span className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400">
                🔍
              </span>

              <input
                type="text"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                placeholder="Search by Name, Email, Phone Number"
                className="w-full pl-10 pr-4 py-2 border-2 border-gray-200 rounded-lg focus:outline-none focus:border-[#1E293B] text-base"
              />
            </div>
            <div className="sm:w-[25%] md:w-[35%] xl:w-[30%] 2xl:w-[25%]">
              <button
                onClick={() => {
                  navigate("/dashboard/create-user?page=usermanagment");
                }}
                class="relative inline-flex items-center gap-2 px-6 py-3 font-semibold text-white text-sm rounded-lg bg-gradient-to-b from-[#0f172a] to-[#1E293B] shadow-md hover:-translate-y-1 hover:shadow-lg transition duration-300 overflow-hidden group"
              >
                <span class="absolute inset-0 bg-white/20 rounded-full scale-0 group-hover:scale-150 transition-transform duration-700 ease-out"></span>
                <UsersRound className="h-5 w-5 min-w-[20px]" />
                <span class="relative">Create User</span>
              </button>
            </div>
          </div>
        </div>
        <div className="overflow-x-auto">
          <table className="w-full min-w-[700px]">
            <thead>
              <tr className="bg-gray-50">
                <th className="px-4 py-3 text-left font-semibold text-gray-500 text-xs uppercase tracking-wider">
                  Name
                </th>
                <th className="px-4 py-3 text-center font-semibold text-gray-500 text-xs uppercase tracking-wider">
                  Email
                </th>
                <th className="px-4 py-3 text-center font-semibold text-gray-500 text-xs uppercase tracking-wider">
                  Phone Number
                </th>
                <th className="px-4 py-3 text-center font-semibold text-gray-500 text-xs uppercase tracking-wider">
                  Role
                </th>
                <th className="px-4 py-3 text-center font-semibold text-gray-500 text-xs uppercase tracking-wider">
                  Status
                </th>
                <th className="px-4 py-3 text-center font-semibold text-gray-500 text-xs uppercase tracking-wider">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody>
              {filteredUsers.length === 0 ? (
                <tr>
                  <td
                    colSpan={6}
                    className="px-4 py-10 text-center text-gray-500 text-sm"
                  >
                    No users found
                  </td>
                </tr>
              ) : (
                filteredUsers.map((item, i) => (
                  <tr
                    key={i}
                    className="hover:bg-gray-50 transition-colors duration-200 border-b border-gray-200"
                  >
                    <td className="px-4 py-3 font-medium text-gray-800 whitespace-nowrap">
                      <div className="flex items-center gap-x-2">
                        {item?.profilepicture ? (
                          <img
                            src={item.profilepicture}
                            alt="user"
                            className="size-7 rounded-full object-cover"
                          />
                        ) : (
                          <div className="size-8 rounded-full bg-gray-100 flex justify-center items-center">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              fill="none"
                              viewBox="0 0 24 24"
                              strokeWidth={1.5}
                              stroke="currentColor"
                              className="size-[18px]"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="M15.75 6a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0ZM4.501 20.118a7.5 7.5 0 0 1 14.998 0A17.933 17.933 0 0 1 12 21.75c-2.676 0-5.216-.584-7.499-1.632Z"
                              />
                            </svg>
                          </div>
                        )}
                        <p>
                          {item.firstname} {item.lastname}
                        </p>
                      </div>
                    </td>

                    <td className="px-2 py-3 text-gray-700 text-center">
                      {item.email}
                    </td>

                    <td className="px-2 py-3 text-gray-700 text-center">
                      {item.phonenumber}
                    </td>

                    <td className=" py-3 text-center">
                      <p className="bg-gray-100 rounded-full px-2 py-2 text-xs lg:text-sm">
                        {item.role === "Admin"
                          ? "Team Lead"
                          : item.role === "Employee"
                            ? "Real Estate Agent"
                            : item.role === "Accountant"
                              ? "Accountant"
                              : "Client Care"}
                      </p>
                    </td>

                    <td className="px-4 py-3 text-center">
                      <p
                        className={`${
                          item.type === 2 ? "bg-red-500" : "bg-green-500"
                        } rounded-full px-2 py-1 text-white text-xs lg:text-sm`}
                      >
                        {item.type === 2 ? "Disabled" : "Active"}
                      </p>
                    </td>

                    <td className="px-4 py-3 text-center">
                      <div className="flex justify-center gap-x-3">
                        {(item.role != "Admin" ||
                          (item.id !== user.id &&
                            user.superadmin === true)) && (
                          <>
                            {item.type === 2 ? (
                              <UserRoundPen
                                size={20}
                                className="text-gray-400 cursor-not-allowed"
                              />
                            ) : (
                              <Link
                                to={`/dashboard/update-user/${item.id}?page=usermanagment`}
                              >
                                <UserRoundPen
                                  size={20}
                                  className="text-blue-600 cursor-pointer"
                                />
                              </Link>
                            )}
                          </>
                        )}
                        {user.role === "Admin" &&
                          item.role === "Supervisor" && (
                            <Key
                              size={20}
                              className="text-green-600 cursor-pointer"
                              onClick={() => handleAccess(item)}
                            />
                          )}
                        {(item.role != "Admin" ||
                          (item.id !== user.id &&
                            user.superadmin === true)) && (
                          <>
                            <Trash2
                              size={20}
                              className="text-red-600 cursor-pointer"
                              onClick={() => handleDelete(item.id)}
                            />
                          </>
                        )}
                        {(item.role != "Admin" ||
                          (item.id !== user.id &&
                            user.superadmin === true)) && (
                          <>
                            {item.type === 2 ? (
                              <Power
                                size={20}
                                className="text-gray-400 cursor-pointer"
                                onClick={() => handleDisable(item.id)}
                              />
                            ) : (
                              <PowerOff
                                size={20}
                                className="text-gray-400 cursor-pointer"
                                onClick={() => handleDisable(item.id)}
                              />
                            )}
                          </>
                        )}

                        {item.role != "Supervisor" &&
                          item.role != "Accountant" && (
                            <>
                              {item.rankingaccess ? (
                                <FaRankingStar
                                  size={20}
                                  className="text-green-600 cursor-pointer"
                                  onClick={() => handleranking(item)}
                                />
                              ) : (
                                <FaRankingStar
                                  size={20}
                                  className="text-gray-400 cursor-pointer"
                                  onClick={() => handleranking(item)}
                                />
                              )}
                            </>
                          )}
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
      {isOpen && (
        <DeleteDisable
          userId={userId}
          mood={mood}
          onClose={() => setIsOpen(false)}
        />
      )}
      {isAccess && (
        <AccessRole onClose={() => setIsAccess(false)} userData={userId} />
      )}
    </div>
  );
}

export default MainUserManagement;
